import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'

import { Button, Icon } from '../../../../components/UI'
import ChangeTimeCalendarView from './ChangeTimeCalendarView'

import { getUserName } from '../../../../helpers'

const ChangeTime = ({ open, data, onClose, onContinue }) => {
  const [selectedSlot, setSelectedSlot] = useState(null)

  // TODO
  const isLoading = false

  const classBanner = data?.availability_calendar_detail?.class_banner

  const handleContinue = () => {
    // TODO
    // onContinue(selectedSlot);
    onContinue(data.availability_calendar_detail)
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'xl:!max-w-[1200px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      {data && classBanner && (
        <div className="w-full flex flex-col items-center justify-center">
          <div className="w-full flex items-center justify-center">
            <Icon name="swap-box-fill" color="#F79009" className="w-[24px] h-[24px] mr-[10px]" />

            <h2 className="text-2xl font-bold text-primary-100">
              Change Time - {classBanner.class_banner_category?.name}, with{' '}
              {getUserName(
                classBanner.class_banner_creator,
                classBanner.creator_profile?.display_name,
                classBanner.creator_profile?.display_last_name
              )}
            </h2>
          </div>

          <h3 className="mt-[20px] text-base text-primary-100 font-normal">
            Please select a time that is more suitable to you
          </h3>

          <ChangeTimeCalendarView
            data={data}
            selectedSlot={selectedSlot}
            setSelectedSlot={setSelectedSlot}
          />

          <div className="w-full flex items-start justify-between mt-[16px]">
            <div className="flex items-center">
              <div className="flex items-center">
                <div className="mr-[14px] w-[20px] h-[20px] bg-[#1AC057] rounded-[3px]" />

                <span className="text-base font-normal text-primary-100">Available time slots</span>
              </div>
            </div>

            <div className="flex items-center">
              <button
                onClick={onClose}
                className="w-[200px] rounded-lg h-[44px] mr-[10px] px-6 bg-white text-[#F79009] border-[1px] border-[#F79009] font-semibold hover:text-white hover:!border-primary-button-hover hover:!bg-primary-button-hover transition-colors duration-200 ease"
              >
                Cancel
              </button>

              <Button
                className="w-[200px] font-semibold"
                onClick={handleContinue}
                // disabled={!selectedSlot}
                isLoading={isLoading}
              >
                Confirm Change
              </Button>
            </div>
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default ChangeTime
